import { MealAvoidanceCategory, MealAvoidanceOptionUIData } from "../types"

/** Data for displaying avoidance options in UI */
const avoidance_options: MealAvoidanceOptionUIData[] = [
  {
    category: MealAvoidanceCategory.GLUTEN,
    icon: "wheat",
    iconColor: "#CF9B07",
    color: "rgba(255, 191, 9, 0.15)",
  },

  {
    category: MealAvoidanceCategory.DAIRY,
    icon: "cow",
    iconColor: "#535AF1",
    color: "rgba(83, 90, 241, 0.15)",
  },

  {
    category: MealAvoidanceCategory.SEAFOOD,
    icon: "fish",
    iconColor: "#1080CC",
    color: "rgba(20, 160, 255, 0.15)",
  },

  {
    category: MealAvoidanceCategory.RED_MEAT,
    icon: "steak",
    iconColor: "#FF7B43",
    color: "rgba(255, 123, 67, 0.15)",
  },

  {
    category: MealAvoidanceCategory.FAT,
    icon: "bacon",
    iconColor: "#CF9B07",
    color: "rgba(255, 191, 9, 0.15)",
  },

  {
    category: MealAvoidanceCategory.CARBS,
    icon: "bread-loaf",
    iconColor: "#1080CC",
    color: "rgba(20, 160, 255, 0.15)",
  },
]

export default avoidance_options
